import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./components/auth/LoginPage";
import OTPInput from "./components/auth/OTPInput";
import ForgotPasswordPage from "./components/auth/ForgotPasswordPage";
import ResetPasswordPage from "./components/auth/ResetPasswordPage";
import Merchants from "./components/Merchants/Merchants";
import MerchantManager from "./components/Merchants/MerchantManager";
import Devices from "./components/Devices";
import DeviceTypes from "./components/DeviceTypes";
import Dashboard from "./components/Dashboard";
import Staff from "./components/Staff/Staff";
import AnalyticsPage from "./components/Analytics";
import PaymentsAdmin from "./components/Payments";
import SalesDetailedView from "./components/Analytics/SalesDetailedView/SalesDetailedView";
import Operations from "./components/Operations";
import SettingsPage from "./components/Settings/Settings";
import Reports from "./components/Reports";
import HelpSupport from "./components/HelpSupport/index";
import Items from "./components/Items/Items";
import Customizations from "./components/Menu/Customisations/Customisations";
import Orders from "./components/Orders";
import DeviceAssignment from "./components/DeviceAssignment";
import Schedules from "./components/Schedules";
import Menus from "./components/Menu/Menus.js";
import Categories from "./components/Menu/Categories/Categories";
import Menu from "./components/Menu/Menu.js";
import { DEFAULT_MENU_TAB_SLUG } from "./components/Menu/Constant";
import MerchantAnalytics from "./components/Analytics/MerchantAnalytics/MerchantAnalytics";
import CategorySales from "./components/Analytics/CategorySales";
import ItemSales from "./components/Analytics/ItemSales";
import Customers from "./components/Analytics/Customers";
import Disputes from "./components/Analytics/Disputes";
import DisputeManagement from "./components/DisputeManagement/DisputeManagement";
import Promotions from "./components/Promotions/Promotions";
import RoleManagement from "./components/RoleManagement/RoleManagement";
import ActiveSessionsDevices from "./components/Analytics/ActiveSessionsAndDevices";
import ActionLogs from "./components/ActionLogs";
import NotFoundPage from "./components/NotFound";
import Stores from "./components/Stores/Stores";
import Loyalty from "./components/Loyalty";
import Configuration from "./components/Configuration/Configuration";
// import MerchantConfigurations from "./components/MerchantConfigurations/MerchantConfigurations.js";
import MerchantCategories from "./components/MerchantCategories/MerchantCategories.js";
import EmailTemplateList from "./components/EmailTemplates/EmailTemplateList/EmailTemplateList";
import ProfitMargins from "./components/Analytics/ProfitMargins";
import DeliveryCostAnalysis from "./components/Analytics/DeliveryCostAnalysis";
import PopularItems from "./components/Analytics/PopularItems";
import TrendingItems from "./components/Analytics/TrendingItems";
import ItemPerformanceComparison from "./components/Analytics/ItemPerformanceComparison";
import WeeklyReports from "./components/Reports/WeeklyReports";
import MonthlyReports from "./components/Reports/MonthlyReports";
import CustomRangeReports from "./components/Reports/CustomRangeReports";
import MerchantEarnings from "./components/Reports/MerchantEarnings/index";
import MerchantEarningsOverview from "./components/Admin/MerchantEarningsOverview";
import CreatorProgram from "./components/CreatorProgram";
import CreatorDetail from "./components/CreatorProgram/CreatorDetail";
import { DEFAULT_TAB_SLUG as DEFAULT_CREATOR_TAB_SLUG } from "./components/CreatorProgram/constants";

// `/menu` alone has no sub-tab context, so send it to the default tab's route.
const MenuIndexRedirect = () => <Navigate to={`/menu/${DEFAULT_MENU_TAB_SLUG}`} replace />;

// Same for `/creator-program` — the active tab always lives in the URL.
const CreatorProgramIndexRedirect = () => (
  <Navigate to={`/creator-program/${DEFAULT_CREATOR_TAB_SLUG}`} replace />
);

const staticAdminRoutes = [
  {
    path: "/otpverify",
    component: OTPInput,
  },
  {
    path: "/login",
    component: LoginPage,
  },
  {
    path: "/forgot-password",
    component: ForgotPasswordPage,
  },
  {
    path: "/reset-password",
    component: ResetPasswordPage,
  },
  {
    path: "/merchants",
    component: Merchants,
  },
  {
    path: "/devices",
    component: Devices,
  },
  {
    path: "/device-types",
    component: DeviceTypes,
  },
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/merchantmanager",
    component: MerchantManager,
  },
  {
    path: "/staff",
    component: Staff,
  },
  {
    path: "/analytics",
    component: AnalyticsPage,
  },
  {
    path: "/payments",
    component: PaymentsAdmin,
  },
  {
    path: "/sales",
    component: SalesDetailedView,
  },
  {
    path: "/operations",
    component: Operations,
  },
  {
    path: "/settings",
    component: SettingsPage,
  },
  {
    path: "/reports",
    component: Reports,
  },
  {
    path: "/help-support",
    component: HelpSupport,
  },
  {
    path: "/items",
    component: Items,
  },
  {
    path: "/customizations",
    component: Customizations,
  },
  {
    path: "/orders",
    component: Orders,
  },
  {
    path: "/deviceassignment",
    component: DeviceAssignment,
  },
  {
    path: "/schedules",
    component: Schedules,
  },
  {
    path: "/menus",
    component: Menus,
  },
  {
    path: "/categories",
    component: Categories,
  },
  {
    path: "/merchantcategories",
    component: MerchantCategories,
  },
  {
    path: "/menu",
    component: MenuIndexRedirect,
  },
  {
    path: "/menu/:tab",
    component: Menu,
  },
  {
    path: "/analytics",
    component: MerchantAnalytics,
  },
  {
    path: "/analytics/sales",
    component: SalesDetailedView,
  },
  {
    path: "/analytics/category-sales",
    component: CategorySales,
  },
  {
    path: "/analytics/item-sales",
    component: ItemSales,
  },
  // Merchant Reports under Analytics
  {
    path: "/analytics/weekly",
    component: WeeklyReports,
  },
  {
    path: "/analytics/monthly",
    component: MonthlyReports,
  },
  {
    path: "/analytics/custom-range",
    component: CustomRangeReports,
  },
  {
    path: "/analytics/customers",
    component: Customers,
  },
  {
    path: "/analytics/disputes",
    component: Disputes,
  },
  {
    path: "/dispute-management",
    component: DisputeManagement,
  },
  {
    path: "/promotions",
    component: Promotions,
  },
  {
    path: "/creator-program",
    component: CreatorProgramIndexRedirect,
  },
  {
    path: "/creator-program/:tab",
    component: CreatorProgram,
  },
  // Sibling of `/creator-program/:tab` rather than a tab — the extra path segment
  // keeps the two from colliding.
  {
    path: "/creator-program/creator/:id",
    component: CreatorDetail,
  },
  {
    path: "/analytics/profit-margins",
    component: ProfitMargins,
  },
  {
    path: "/analytics/delivery-cost-analysis",
    component: DeliveryCostAnalysis,
  },
  {
    path: "/analytics/popular-items",
    component: PopularItems,
  },
  {
    path: "/analytics/trending-items",
    component: TrendingItems,
  },
  {
    path: "/analytics/item-performance-comparison",
    component: ItemPerformanceComparison,
  },
  {
    path: "/reports/weekly-reports",
    component: WeeklyReports,
  },
  {
    path: "/reports/monthly-reports",
    component: MonthlyReports,
  },
  {
    path: "/reports/custom-range-reports",
    component: CustomRangeReports,
  },
  {
    path: "/merchant/earnings",
    component: MerchantEarnings,
  },
  {
    path: "/admin/merchant-earnings",
    component: MerchantEarningsOverview,
  },
  {
    path: "/activesessionanddevices",
    component: ActiveSessionsDevices,
  },
  {
    path: "/logs",
    component: ActionLogs,
  },
  {
    path: "*",
    component: NotFoundPage,
  },
  {
    path: "/stores",
    component: Stores,
  },
  {
    path: "/loyalty",
    component: Loyalty,
  },
  {
    path: "/sales-analytics",
    component: MerchantAnalytics,
  },
  {
    path: "/configuration",
    component: Configuration,
  },
  {
    path: "/email-templates",
    component: EmailTemplateList,
  },
  {
    path: "/role-management",
    component: RoleManagement,
  },
];

const roleBasedComponents = {};

function AppRoutes({ dynamicRoutes, role }) {
  const roleComponents = roleBasedComponents[role] || {};

  const allRoutes = [
    ...staticAdminRoutes,
    ...dynamicRoutes.map((item) => {
      return {
        path: item.slug,
        component:
          roleComponents[item.page.toLowerCase()] ||
          (() => <div>{item.page}</div>),
      };
    }),
  ];

  return (
    <>
      <Routes>
        {allRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={React.createElement(route.component, { role })}
          />
        ))}
      </Routes>
    </>
  );
}

export default AppRoutes;
